import { useEffect } from "react";

import { SkipRules } from "./SkipRules";
import type { SkipReason } from "./types";

/**
 * Calls SkipRules.notify(reason) on mount, SkipRules.clear(reason) on unmount.
 * Pass `active = false` to no-op (useful for components whose presence in the
 * tree doesn't always equal "scene is showing", e.g. modals gated on `visible`).
 *
 * Visit Recording: when the recorder is active, SkipRules subscribers emit
 * capture_paused / capture_resumed events on transitions — this is how the
 * player UI shows "Capture paused — reconstructed artifact" overlays.
 *
 * Outside an active visit (recorder not started), SkipRules.notify is a
 * harmless internal toggle — no events fire and no state escapes the module.
 */
export function useSkipRule(reason: SkipReason, active = true): void {
    useEffect(() => {
        if (!active) {
            return;
        }
        SkipRules.notify(reason);
        return () => {
            SkipRules.clear(reason);
        };
    }, [reason, active]);
}
